// Styles
import styles from './PromoCodesIsEmpty.module.scss';

const PromoCodesIsEmpty = ({ title, text }: { text: string; title: string }) => {
    return (
        <div className={styles.containerEmpty}>
            <img
                className={styles.imageEmpty}
                src="/images/memberships/clients-notfound.svg"
                alt="No promo codes"
            />
            <h2 className={styles.titleEmpty}>{title}</h2>
            <div className={styles.descriptionEmptyContainer}>
                <p className={styles.descriptionEmpty}>{text}</p>
            </div>
        </div>
    );
};

export default PromoCodesIsEmpty;
